import { render, staticRenderFns } from "./UnitCardDiscontinued.vue?vue&type=template&id=431c40f4&"
import script from "./UnitCardDiscontinued.vue?vue&type=script&lang=js&"
export * from "./UnitCardDiscontinued.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports